<template>
  <div class="patient-select-list">
    <b-row class="mb-3">
      <b-col :cols="4">
        <basic-input
          placeholder="Nhập thông tin tìm kiếm"
          :debounce="500"
          :value.sync="filter.filterStr"
          @update:value="handleSearch"
          v-b-tooltip="`Bạn có thể tìm khách hàng bằng số điện thoại, tên , mã định danh`"
        />
      </b-col>
      <!-- <b-col :cols="4">
        <basic-input
          label="Tìm theo SĐT"
          placeholder="Nhập số điện thoại"
          :debounce="500"
          :value.sync="filter.phone"
          @update:value="handleSearch"
        />
      </b-col> -->
      <!-- <b-col :cols="4">
        <b-form-group id="dateRange">
          <date-picker
            :range="true"
            :clearable="true"
            input-class="form-control"
            type="date"
            format="DD/MM/YYYY"
            value-type="date"
            v-model="filter.dateRange"
            placeholder="Thời gian khám"
          />
        </b-form-group>
      </b-col> -->
    </b-row>

    <b-row>
      <b-col :cols="12">
        <template-table
          :column="columns"
          :data="filteredPatients"
          :paging="paging"
          :tableAction="false"
          :selectAction="false"
          :searchAction="false"
          @sortBy="handleSort"
        >
          <template v-slot:body="{ item, index }">
            <td>{{ getRowIndex(index) }}</td>
            <td>{{ item.fullName }}</td>
            <td>{{ formatPhone(item.phoneNumber) }}</td>
            <td>{{ formatDate(item.dateOfBirth) }}</td>
            <td>
              <span
                class="badge"
                :class="item.tag === 'DiaB' ? 'badge-primary' : 'badge-warning'"
              >
                {{ item.tag }}
              </span>
            </td>
            <td>
              <b-button
                size="sm"
                variant="success"
                @click="handleSelectPatient(item)"
              >
                Chọn
              </b-button>
            </td>
          </template>
        </template-table>
      </b-col>
    </b-row>
  </div>
</template>

<script>
// import DatePicker from 'vue2-datepicker';
import moment from 'moment-timezone';

export default {
  name: 'PatientSelectList',
  components: {
    // 'date-picker': DatePicker,
  },
  data() {
    return {
      columns: [
        { key: 'stt', label: 'STT', style: 'width: 60px' },
        { key: 'fullName', label: 'Họ và tên' },
        { key: 'phoneNumber', label: 'Số điện thoại' },
        { key: 'dateOfBirth', label: 'Ngày sinh' },
        { key: 'source', label: 'Nguồn', style: 'width: 100px' },
        { key: 'action', label: 'Thao tác', style: 'width: 100px' },
      ],
      patients: [],
      paging: {
        page: 1,
        pageSize: 10,
        total: 0,
      },
      sort: {
        by: null,
        order: null,
      },
      filter: {
        filterStr: null,
        phone: null,
        dateRange: null,
      },
      isLoading: false,
    };
  },
  computed: {
    searchParams() {
      const params = {
        page: this.paging.page,
        size: this.paging.pageSize,
      };

      if (this.filter.filterStr) {
        params.filterStr = this.filter.filterStr;
      }

      if (this.filter.phone) {
        let phone = this.filter.phone;
        if (phone.startsWith('0')) {
          phone = phone.substring(1);
        }
        params.phone = phone;
      }

      if (this.sort.by) {
        params.orderBy = `${this.sort.by} ${this.sort.order}`;
      }

      return params;
    },
    filteredPatients() {
      if (!this.filter.dateRange || this.filter.dateRange.length !== 2) {
        return this.patients;
      }
      const startDate = moment(this.filter.dateRange[0]).startOf('day').unix();
      const endDate = moment(this.filter.dateRange[1]).endOf('day').unix();
      return this.patients.filter((patient) => {
        if (!patient.createDatetime) return false;
        return patient.createDatetime >= startDate && patient.createDatetime <= endDate;
      });
    },
  },
  watch: {
    'paging.page'() {
      this.loadData();
    },
    'paging.pageSize'() {
      this.loadData();
    },
  },
  methods: {
    getRowIndex(index) {
      return (this.paging.page - 1) * this.paging.pageSize + index + 1;
    },

    handleSort(val) {
      this.sort.by = val.column;
      this.sort.order = val.order;
      this.loadData();
    },

    handleSearch() {
      this.paging.page = 1;
      this.loadData();
    },

    async loadData() {
      // Require at least name or phone to search
      if (!this.filter.filterStr && !this.filter.phone) {
        this.patients = [];
        this.paging.total = 0;
        return;
      }

      this.$store.commit('context/setLoading', true);
      this.isLoading = true;

      try {
        const response = await this.$api.get('/Patient/Search', {
          params: this.searchParams,
        });

        this.patients = response.data.items ?? [];
        this.paging.total = response.data.total ?? 0;
      } catch (error) {
        console.error('Error loading patients:', error);
        this.$toastr.e({
          title: 'Lỗi',
          msg: 'Không thể tải danh sách bệnh nhân',
        });
      } finally {
        this.$store.commit('context/setLoading', false);
        this.isLoading = false;
      }
    },

    formatPhone(phone) {
      if (!phone) return '';
      return phone.replace('+84', '0');
    },

    formatDate(timestamp) {
      if (!timestamp) return '';
      return moment.unix(timestamp).format('DD/MM/YYYY');
    },

    handleSelectPatient(patient) {
      this.$emit('select', patient);
    },
  },
};
</script>

<style lang="scss" scoped>
.patient-select-list {
  padding: 10px 0;

  .badge-primary {
    background-color: #01645a;
    color: white;
  }

  .badge-warning {
    background-color: #ffa800;
    color: white;
  }
}
</style>
